import { common } from './modules/common';
common();
import { scrollHighlight } from './modules/scrollHighlight';
scrollHighlight();